import clsx from 'clsx';
import React from 'react';
import Spinner from '../../../static/Spinner-0.7s-277px.svg';

const LoadingSpinner = ({ hide, variant }) => {
  if (hide) return null;
  return <Spinner className={clsx("LoadingSpinner", variant)} />;
};

export default LoadingSpinner;
